import React, { Component } from 'react';
import { AuthConsumer } from '../../../auth/AuthContext';
import withStyles from '@material-ui/core/styles/withStyles';
import Cancel from '@material-ui/icons/CancelOutlined';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
// @material-ui/icons
import Close from '@material-ui/icons/Close';
// core components
import Button from 'components/CustomButtons/Button.jsx';

import modalSstyles from 'assets/jss/material-dashboard-pro-react/modalStyle.jsx';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// @material-ui/icons
import Check from '@material-ui/icons/Check';
import Checkbox from '@material-ui/core/Checkbox';

import checkboxStyles from 'assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx';
import tenantRoles from '../../../auth/tenantRoles';

const styles = { ...modalSstyles, ...checkboxStyles };

class DeleteUserButton extends Component {
  state = {
    showModal: false,
    approved: false,
  };
  showModal = () => {
    this.setState({
      showModal: true,
      approved: false,
    });
  };
  hideModal = () => {
    this.setState({ showModal: false, approved: false });
  };

  onApproveChanged = event => {
    this.setState({
      approved: event.target.checked,
    });
  };

  onConfirm = () => {
    const { onDeleteUser } = this.props;
    onDeleteUser();
    this.hideModal();
  };
  render() {
    const { classes, loading } = this.props;
    const { approved, showModal } = this.state;
    return (
      <AuthConsumer>
        {({ isAuthorized }) =>
          isAuthorized([tenantRoles.SUPER_ADMIN]) ? (
            <React.Fragment>
              <Button
                color={loading ? undefined : 'warning'}
                onClick={this.showModal}
                disabled={loading}
              >
                <span style={{ marginRight: 10 }}>Benutzer löschen</span>
                <Cancel />
              </Button>
              <Dialog
                classes={{
                  root: classes.center,
                  paper: classes.modal,
                }}
                open={showModal}
                keepMounted
                onClose={this.hideModal}
              >
                <DialogTitle
                  id="classic-modal-slide-title"
                  disableTypography
                  className={classes.modalHeader}
                >
                  <Button
                    justIcon
                    className={classes.modalCloseButton}
                    key="close"
                    color="transparent"
                    onClick={this.hideModal}
                  >
                    <Close className={classes.modalClose} />
                  </Button>
                </DialogTitle>
                <DialogContent
                  id="modal-slide-description"
                  className={classes.modalBody}
                  style={{ marginBottom: 20 }}
                >
                  <h5>Willst du diesen Benutzer wirklich löschen?</h5>
                  <h6>
                    Der Benutzer wird von allen Systemen gelöscht (Concardis,
                    Braze, Skidata etc...). Intern wird der Benutzer
                    anonymisiert. Der Vor / Nachname wird zu 'anonymized'
                    gewechselt und die email gelöscht. Diese Operation ist nicht
                    umkehrbar!
                  </h6>
                  <FormControlLabel
                    control={
                      <Checkbox
                        tabIndex={-1}
                        onClick={this.onApproveChanged}
                        checked={approved}
                        checkedIcon={<Check className={classes.checkedIcon} />}
                        icon={<Check className={classes.uncheckedIcon} />}
                        classes={{ checked: classes.checked }}
                      />
                    }
                    classes={{ label: classes.label }}
                    label={'Ich will diesen Benutzer löschen'}
                  />
                </DialogContent>
                <DialogActions
                  className={
                    classes.modalFooter + ' ' + classes.modalFooterCenter
                  }
                >
                  <Button onClick={this.hideModal}>Abbrechen</Button>
                  <Button
                    onClick={this.onConfirm}
                    color="danger"
                    disabled={!approved}
                  >
                    Benutzer unwiderruflich löschen
                  </Button>
                </DialogActions>
              </Dialog>
            </React.Fragment>
          ) : null
        }
      </AuthConsumer>
    );
  }
}

export default withStyles(styles)(DeleteUserButton);



// WEBPACK FOOTER //
// ./src/views/users/components/DeleteUserButton.jsx